import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Login from "./pages/Login";
import Mentors from "./pages/Mentors";
import MentorDashboard from "./pages/MentorDashboard";
import Navbar from "./components/Navbar";
import Register from "./pages/Register";
import MyBookings from "./pages/MyBookings";
import EditStudentProfile from "./pages/EditStudentProfile";
import EditMentorProfile from "./pages/EditMentorProfile";
import CalendarBooking from "./pages/CalendarBooking";
import LandingPage from "./pages/LandingPage";
import Notifications from "./pages/Notifications";
import VerifyEmail from "./pages/VerifyEmail";

const sharedProtectedChildren = (page) => ({
  student: page,
  mentor: page,
});

function App() {
  return (
    <AuthProvider>
      <Router>
        <Navbar />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/home" element={<LandingPage />} />
          <Route path="/register" element={<Register />} />
          <Route path="/login" element={<Login />} />
          <Route path="/mentors" element={<Mentors />} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute mentorOnly={true}>
                {{
                  mentor: <MentorDashboard />,
                }}
              </ProtectedRoute>
            }
          />
          <Route
            path="/mybookings"
            element={
              <ProtectedRoute>
                {sharedProtectedChildren(<MyBookings />)}
              </ProtectedRoute>
            }
          />
          <Route
            path="/editprofile"
            element={
              <ProtectedRoute>
                {{
                  student: <EditStudentProfile />,
                  mentor: <EditMentorProfile />,
                }}
              </ProtectedRoute>
            }
          />
          <Route
            path="/calendar"
            element={
              <ProtectedRoute>
                {sharedProtectedChildren(<CalendarBooking />)}
              </ProtectedRoute>
            }
          />
          <Route
            path="/calendar/:mentorId"
            element={
              <ProtectedRoute>
                {sharedProtectedChildren(<CalendarBooking />)}
              </ProtectedRoute>
            }
          />
          <Route
            path="/notifications"
            element={
              <ProtectedRoute>
                {sharedProtectedChildren(<Notifications />)}
              </ProtectedRoute>
            }
          />
          <Route path="/verify-email" element={<VerifyEmail />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
